import React from 'react';
import cn from 'classnames';

import * as styles from './MetaList.module.css';

const MetaList = ({ label, value, inline = false }) => {
  return (
    <dl className={cn(styles.root, { [styles.inline]: inline })}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </dl>
  );
};

export default MetaList;
